import { HStack, Modal, ModalContent, ModalOverlay } from "@chakra-ui/react";

type FormModalTemplateProps = {
    form: React.ReactNode;
    isOpenModal?: boolean;
    onCloseModal?: () => void | Promise<void>;
}

const FormModalTemplate = ({
    form,
    isOpenModal,
    onCloseModal
}: FormModalTemplateProps) => {
    return (
        <Modal
            isOpen={isOpenModal ?? false}
            onClose={() => onCloseModal?.()}
            onEsc={onCloseModal}
            onOverlayClick={onCloseModal}
            size="lg"
        >
            <ModalOverlay />
            <ModalContent>
                <HStack spacing={5} align="flex-start" flex={1} w="full">
                    {form}
                </HStack>
            </ModalContent>
        </Modal>
    )
}

export default FormModalTemplate